import dayjs, { Dayjs } from 'dayjs';

/**
 * Redondea una fecha al siguiente intervalo de 30 minutos
 * Ejemplos:
 * - 16:55 → 17:00
 * - 16:23 → 16:30
 * - 16:45 → 17:00
 * - 16:30 → 16:30 (ya está redondeado)
 */
export function roundToNext30Minutes(date: Dayjs | Date): Dayjs {
  const dayjsDate = dayjs(date);
  const minutes = dayjsDate.minute();
  
  // Si ya está en :00 o :30, no cambiar
  if (minutes === 0 || minutes === 30) {
    return dayjsDate.second(0).millisecond(0);
  }
  
  // Si está entre :01 y :30, redondear a :30
  if (minutes > 0 && minutes < 30) {
    return dayjsDate.minute(30).second(0).millisecond(0);
  }
  
  // Si está entre :31 y :59, redondear a la siguiente hora en :00
  return dayjsDate.add(1, 'hour').minute(0).second(0).millisecond(0);
}
